import { APIRequest } from '../../helpers/index.helper';
import { APP_TEXT_ENDPOINT } from '../../apiEndpoints/index.endpoint';
import { logger } from '../../utils';
export const tipsService = async (body) => {
  try {
    const payload = {
      ...APP_TEXT_ENDPOINT.tipInformation,
      bodyData: body,
    };
    const res = await APIRequest(payload);
    return res;
  } catch (err) {
    logger(err);
  }
};

export const getTipsService = async ({ queryParams }) => {
  try {
    const payload = {
      ...APP_TEXT_ENDPOINT.getTipInformation,
      queryParams,
    };
    const res = await APIRequest(payload);
    return res;
  } catch (err) {
    logger(err);
  }
};
